import type { FlowTemplateFlowType } from './constants'
import { formatEmailCount, formatFlowSpan } from './format-flow-timing'

/** How the two kinds of collected flow read in the product. */
export const FLOW_TYPE_LABEL: Readonly<Record<FlowTemplateFlowType, string>> = {
  signup: 'Signup sequence',
  newsletter: 'Newsletter',
}

/** The flows gallery's name and description: its metadata and its Markdown twin. */
export const FLOWS_GALLERY_TITLE = 'Email Flows'

export const FLOWS_GALLERY_DESCRIPTION =
  'Browse real signup and newsletter email flows from top brands. See every step, then remix the whole sequence for your brand with AI.'

/** One flow's title: its page metadata, structured data and Markdown twin. */
export function flowPageTitle(flow: {
  brandName: string
  emailCount: number
}): string {
  return `${flow.brandName} email flow: ${formatEmailCount(flow.emailCount)}`
}

/** One flow's description: its page metadata and its Markdown twin. */
export function describeFlow(flow: {
  brandName: string
  flowType: FlowTemplateFlowType
  emailCount: number
  spanDays: number
}): string {
  const span = flow.spanDays > 0 ? ` over ${formatFlowSpan(flow.spanDays)}` : ''
  return `See every email ${flow.brandName} sends in its ${FLOW_TYPE_LABEL[flow.flowType].toLowerCase()}: ${formatEmailCount(flow.emailCount)}${span}. Remix the whole sequence onto your brand with Brew.`
}
